import { render, staticRenderFns } from "./GoalCardFooter.vue?vue&type=template&id=0747d8b2&scoped=true"
import script from "./GoalCardFooter.vue?vue&type=script&lang=js"
export * from "./GoalCardFooter.vue?vue&type=script&lang=js"
import style0 from "./GoalCardFooter.vue?vue&type=style&index=0&id=0747d8b2&prod&lang=less&scoped=true"
import style1 from "./GoalCardFooter.vue?vue&type=style&index=1&id=0747d8b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747d8b2",
  null
  
)

export default component.exports